import NavBar from './components/NavBar';
import WelcomePage from './components/WelcomePage';
import Footer from './components/Footer';
import './App.scss';
import './font.css'; 
import CoreVideo from './components/CoreVideo';
function App() {
  return (
    
    <div className="App">
      <NavBar/>
      <CoreVideo/> 
      <WelcomePage/>
      <Footer/>
    </div>
  );
}

export default App;
